import { render } from "./AgentAvatar.vue?vue&type=template&id=37366acb&scoped=true"
import script from "./AgentAvatar.vue?vue&type=script&lang=js"
export * from "./AgentAvatar.vue?vue&type=script&lang=js"

import "./AgentAvatar.vue?vue&type=style&index=0&id=37366acb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37366acb"]])

export default __exports__